import { useEffect, useState } from "react";
import type { GradeSelectorActionType, GradeSelectorDispatchType, GradeSelectorStateType } from "../redux/store";
import { gradeSelectorReducers } from "../redux/store";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import { executeFrontendDataFetch } from "../../../../common-deprecated/hooks/useDataFetcher";
import { getGradeSelectorComponentFetches, gradeSelectorFetchDispatcher } from "../datafetch/fetchUtils";
import type { GetFetchesFnType } from "../../../../common-deprecated/utils/registryTypes";
import { COMPONENT_GRADE_SELECTOR } from "../../../../shared-logic/server/components";
import { setColour, setSelectedMotorization } from "../redux/slices/GradeSelectorModelSlice";
import type { CarMotorizationType } from "../../../shared-logic/types/CarType";
import { useDispatch, useSelector, useStore } from "../../../../shared-logic/redux/store";

const useIntegratedGradeSwitcher = (
    selectedGradeBodyId: string,
    colourId: string,
    motorization: CarMotorizationType,
    modelId?: string,
): { fetching: boolean } => {
    const store = useStore<GradeSelectorStateType, GradeSelectorActionType>();
    const commonSettings = useSelector<{ commonSettings: CommonSettingsType }, CommonSettingsType>(
        (state) => state.commonSettings,
    );
    const dispatch = useDispatch<GradeSelectorDispatchType>();

    const [fetching, setFetching] = useState<boolean>(true);

    useEffect(() => {
        store.addReducers(gradeSelectorReducers);

        const fetchData = async (): Promise<void> => {
            await executeFrontendDataFetch(
                store,
                getGradeSelectorComponentFetches(modelId) as unknown as GetFetchesFnType,
                gradeSelectorFetchDispatcher,
                commonSettings,
                COMPONENT_GRADE_SELECTOR,
                ["brand", "envVarsOverride"],
            );

            setFetching(false);

            dispatch(
                setSelectedMotorization({
                    uniqueBodyTypeId: selectedGradeBodyId,
                    motorization: {
                        engineId: motorization.engine.id,
                        transmissionId: motorization.transmission.id,
                        wheeldriveId: motorization.wheeldrive.id,
                    },
                }),
            );
            dispatch(
                setColour({
                    uniqueBodyTypeId: selectedGradeBodyId,
                    colourId,
                }),
            );
        };

        fetchData();

        // Should only run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { fetching };
};

export default useIntegratedGradeSwitcher;
